import store from "@/store/index.js";
export default {
  users: {
    add(data) {
      return store.dispatch("addUser", data);
    },
    update(data) {
      return store.dispatch("updateUser", data);
    },
    activate(data) {
      return store.dispatch("activateUser", data);
    },
    block(data) {
      return store.dispatch("blockUser", data);
    },
    delete(id) {
      return store.dispatch("deleteUser", id);
    },
    fetchAll() {
      return store.dispatch("fetchAllUsers");
    },
    getAllUsers() {
      return store.getters.getAllUsers;
    },
  },
  settings: {
    update(data) {
      return store.dispatch("updateSetting", data);
    },
    fetchAll() {
      return store.dispatch("fetchAllSettings");
    },
    getAllSettings() {
      return store.getters.getAllSettings;
    },
  },
  customers: {
    add(data) {
      return store.dispatch("addCustomer", data);
    },
    addWithMeter(data) {
      return store.dispatch("addCustomerWithMeter", data);
    },
    update(data) {
      return store.dispatch("updateCustomer", data);
    },
    delete(id) {
      return store.dispatch("deleteCustomer", id);
    },
    fetchAll() {
      return store.dispatch("fetchAllCustomers");
    },
    getAllCustomers() {
      return store.getters.getAllCustomers;
    },
    getCustomerGroups(cid) {
      return store.getters.getCustomerGroups(cid);
    },
    getCustomerMeters(cid) {
      return store.getters.getCustomerMeters(cid);
    },
    addToGroup(data) {
      return store.dispatch("addToGroup", data);
    },
    removeFromGroup(data) {
      return store.dispatch("removeFromGroup", data);
    },
    addMeter(data) {
      return store.dispatch("addMeterToCustomer", data);
    },
    removeMeter(data) {
      return store.dispatch("removeMeterFromCustomer", data);
    },
    updateMeter(data) {
      return store.dispatch("updateMeterOfCustomer", data);
    },
  },
  meters: {
    add(data) {
      return store.dispatch("addMeter", data);
    },
    update(data) {
      return store.dispatch("updateMeter", data);
    },
    delete(id) {
      return store.dispatch("deleteMeter", id);
    },
    fetchAll() {
      return store.dispatch("fetchAllMeters");
    },
    fetchAll_lite() {
      return store.dispatch("fetchAllMeters_lite");
    },
    getAllMeters() {
      return store.getters.getAllMeters;
    },
  },
  groups: {
    add(data) {
      return store.dispatch("addGroup", data);
    },
    update(data) {
      return store.dispatch("updateGroup", data);
    },
    delete(id) {
      return store.dispatch("deleteGroup", id);
    },
    fetchAll() {
      return store.dispatch("fetchAllGroups");
    },
    getAllGroups() {
      return store.getters.getAllGroups;
    },
  },
  readings: {
    add(data) {
      return store.dispatch("addReading", data);
    },
    update(data) {
      return store.dispatch("updateReading", data);
    },
    delete(id) {
      return store.dispatch("deleteReading", id);
    },
    deleteAll() {
      return store.dispatch("deleteAllReadings");
    },
    fetchAll() {
      return store.dispatch("fetchAllReadings");
    },
    getAllReadings() {
      return store.getters.getAllReadings;
    },
  },
  messages: {
    fetchAll() {
      return store.dispatch("fetchAllMessages");
    },
    getAllMessages() {
      return store.getters.getAllMessages;
    },
    readMessage(id) {
      return store.dispatch("readMessage", id);
    },
    addMessage(data) {
      return store.dispatch("addMessage", data);
    },
    send4Cut() {
      return store.dispatch("send4Cut");
    },
  },
  actions: {
    fetchAll(customer_id) {
      return store.dispatch("fetchAllActions", customer_id);
    },
    getAllActions() {
      return store.getters.getAllActions;
    },
    promptCustomer(id) {
      return store.dispatch("promptCustomer", id);
    },
    promptAllCustomers() {
      return store.dispatch("promptAllCustomers");
    },
    promptAllCustomersBySector(sector_id) {
      return store.dispatch("promptAllCustomersBySector", sector_id);
    },
    addPayment(data) {
      return store.dispatch("addPayment", data);
    },
    addFix(data) {
      return store.dispatch("addFix", data);
    },
    delete(id) {
      return store.dispatch("deleteAction", id);
    },
  },
  transactions: {
    fetchAll() {
      return store.dispatch("fetchAllTransactions");
    },
    getAllTransactions() {
      return store.getters.getAllTransactions;
    },
    addWithdraw(data) {
      return store.dispatch("addWithdraw", data);
    },
  },
  stats: {
    fetchAll() {
      return store.dispatch("fetchAllStats");
    },
    getAllStats() {
      return store.getters.getAllStats;
    },
  },
  test_status: {
    setData(data) {
      return store.dispatch("setQuestions", { data });
    },
    getData() {
      return store.getters.getQuestions;
    },
  },
};
